

    import * as T from '@/catalog-app/types';
    import { defineComponent, PropType } from 'vue';
    // ref, reactive, computed, watch,
    // import X from '@/components/X.vue';

    export default defineComponent({
        name: 'Panel',
        components: { },
        props: {
            // prop: Object as PropType<T>
            banner: {
                type: Object as PropType<T.Banner>,
                required: true,
            },
            catalogName: String,
            contactURL: String,
        },
        setup(props, context) {
            return {
            }
        },
        computed: {
            // contactURL(): string {
            //     return `/contact-us/?`;
            // },
        }
    });

